<div class="spinner-color">
   <mat-spinner [diameter]="30" mode="indeterminate"></mat-spinner>
</div>



